<template>
  <v-app id="app" class="logoWrap">
    <section class="d-flex align-center justify-center">
      <div class="logoBx d-flex flex-column justify-center align-center">
        <h1 class="logo">
          <!--                    <img src="@/assets/images/common/logo_admin_login.png" alt="로고" />-->
        </h1>
        <div class="fieldBx">
          <v-col sm="6">
            <v-text-field v-model="loginId" label="아이디를 입력하세요." append-icon="mdi mdi-account"/>
          </v-col>
          <v-col sm="6">
            <v-text-field v-model="loginPw"
                          label="패스워드를 입력하세요."
                          :type="passwordShow ? 'text' : 'password'"
                          :append-icon="passwordShow? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="passwordShow = !passwordShow"
                          @keyup.enter="handleLogin()"/>
          </v-col>
        </div>
        <div class="btn">
          <v-btn class="vIconResize" @click="handleLogin()" color="#1991eb" dark>
            <v-icon left>mdi mdi-login-variant</v-icon>
            로그인
          </v-btn>
        </div>
      </div>
    </section>
  </v-app>
</template>

<script>
import menuApi from "@/api/MenuApi";

export default {
  name: "Login",
  components: {},
  data: () => ({
    loginId: '',
    loginPw: '',
    passwordShow: false,
    allowedMenus: []
  }),
  methods: {
    handleLogin() {
      this.$store.dispatch('user/login', {loginId: this.loginId, loginPw: this.loginPw})
          .then(success => {
            if (success) {
              // this.$router.push('/user');

              this.allowedMenus = this.$store.getters['user/menus'];

              menuApi.list('ADMIN').then(resultSet => {
                // console.log(resultSet);
                const menus = resultSet.map(this.menuParse).filter(m => m !== null).filter(m => !m.protected || this.allowedMenus.includes(m.id));

                // this.$store.commit('setUserMenus', this.menus);
                localStorage.setItem('userMenus', JSON.stringify(menus));

                this.$router.push('/');

              });

            }
          })
          .catch(error => {
            if (error.response) {
              alert(error.response.data.error_description)
            } else
              alert(error.message);
            // console.log(error.message);
            // console.log(error.response);
          });
    },
    menuParse(m) {

      if (!m.activated) {
        return null;
      }

      if (m.menuType === 'TYPE_BOARD') {
        m.url = `/board/${m.boardId}/articles`;
      }

      m.alias = m.url ? m.url + "*" : null;
      return {
        menu: m,
        id: m.menuId,
        protected: m.protected,
        title: m.menuName,
        icon: m.menuIcon,
        href: m.url ?? null,
        // alias: m.alias,
        child: m?.childMenus?.length ?? 0 > 0 ? m?.childMenus?.map(this.menuParse).filter(c => c !== null).filter(c => !c.protected || this.allowedMenus.includes(c.id)) : null
      }
    }
  },
  created() {
    this.$store.commit('setParams', Object.assign({}, {name: this.$options.name}))
  }
}
</script>

<style lang="scss" scoped>
.logoWrap {
  height: 100%;

  section {
    height: 100%;
    background: #f6f8fa;
  }

  .logoBx, .fieldBx {
    width: 600px;

    .col-sm-6 {
      margin: 0 auto;
    }

    .logo {
      margin-bottom: 50px;
    }
  }

  .logoBx {
    padding: 50px 0;
    border-radius: 8px;
    background: #fff;
    box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.2);

  }

  .fieldBx {
    margin-bottom: 20px;

  }

  .vIconResize {
    width: 500px;
    height: 45px !important;
  }
}

.logo {
  display: flex;
  //width: 62px;
  //height: 32px;
  margin: 20px auto;
  width: 119px;
  height: 39px;
  background: url(data:image/png;base64,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) center center no-repeat;
  font-size: 0;
  filter: invert(50%);
}
</style>
